import ipRegex from 'ip-regex'

const defaultIPGeo: IPToLocationMapping = {
  '100.85.43.94': {
    countryName: 'CN6内部地址',
    internal: true,
  },
  '117.28.242.180': {
    countryName: 'CN2内部地址',
    internal: true,
  },
  '112.33.32.141': {
    countryName: 'CN13内部地址',
    internal: true,
  },
  '223.166.24.42': {
    countryName: 'CN5内部地址',
    internal: true,
  },
  '100.76.233.106': {
    countryName: 'CN5内部地址',
    internal: true,
  },
  '100.70.210.77': {
    countryName: 'CN5/3内部地址',
    internal: true,
  },
  '10.200.201.24': {
    countryName: 'CN6内部地址(ens19)',
    internal: true,
  },
  '103.152.227.24': {
    countryName: 'CN6内部地址(ens18)',
    internal: true,
  },
  '218.92.1.3': {
    countryName: 'CN5/3内部地址(wan)',
    internal: true,
  },
  '218.92.1.4': {
    countryName: 'CN5/3内部地址(wan)',
    internal: true,
  },
  '43.248.118.239': {
    countryName: 'CN5/3内部地址(wan)',
    internal: true,
  },
  '27.148.248.170': {
    countryName: 'CN2内部地址(wan)',
    internal: true,
  },
  '27.148.248.171': {
    countryName: 'CN2内部地址(wan)',
    internal: true,
  },
  '27.148.249.188': {
    countryName: 'CN2内部地址(wan)',
    internal: true,
  },
  '27.148.249.11': {
    countryName: 'CN2内部地址(wan)',
    internal: true,
  },
  '27.148.249.12': {
    countryName: 'CN2内部地址(wan)',
    internal: true,
  },
  '27.148.249.189': {
    countryName: 'CN2内部地址(wan)',
    internal: true,
  },
  '100.66.213.23': {
    countryName: 'CN2内部地址(ts)',
    internal: true,
  },
  '27.148.248.236': {
    countryName: 'CN2内部地址(wan)',
    internal: true,
  },
  '27.148.248.237': {
    countryName: 'CN2内部地址(wan)',
    internal: true,
  },
  '27.148.248.238': {
    countryName: 'CN2内部地址(wan)',
    internal: true,
  },
  '27.148.248.239': {
    countryName: 'CN2内部地址(wan)',
    internal: true,
  },
  '100.83.159.51': {
    countryName: 'CN5内部地址(ts)',
    internal: true,
  },
  '127.0.0.1': {
    countryName: '服务器自身地址',
    internal: true,
  },
  '124.151.45.211': {
    countryName: 'CN5入口地址(wan)',
    internal: true,
  },
  '100.73.179.17': {
    countryName: 'CN5内部地址(ts)',
    internal: true,
  },
  '103.200.114.71': {
    countryName: 'CN5出口地址(wan)',
    internal: true,
  },
  '157.254.192.2': {
    countryName: 'CN6出口地址(wan)',
    internal: true,
  },
  '100.97.7.43': {
    countryName: 'CN6内部地址(ts)',
    internal: true,
  },
}

export const useIPGeo = defineStore('ipGeo', () => {
  const ipGeo = ref({ ...defaultIPGeo })
  // const ipArray = ref<string[]>([])
  const ipSet = ref(new Set<string>())
  const ipArray = computed(() => Array.from(ipSet.value))

  const getLocalGeoInfo = (ip?: string) => {
    if (!ip) {
      return {}
    }
    if (ip.startsWith('100.') || ip.startsWith('10.')) {
      return {
        countryName: '内网地址',
        internal: true,
      }
    }
    return ipGeo.value[ip || ''] || {}
  }

  const getIPGeo = async () => {
    const newIPArray = ipArray.value.filter((ip) => !ipGeo.value[ip])
    // console.log('newIPArray:', newIPArray)
    if (!newIPArray.length) {
      return
    }
    ipGeo.value = {
      ...ipGeo.value,
      ...((await useAdmin.getIPGeo({ ip: newIPArray })) || {}),
    }
  }

  const addIP = (ip?: string) => {
    // console.log('addIP:', ip)
    if (ip) {
      ipSet.value.add(ip)
    }
    // getIPGeo()
  }

  const isValidIP = (ip: string) => {
    return ipRegex({ exact: true }).test(ip)
  }

  watchDebounced(
    () => ipSet.value.size,
    () => {
      // console.log('ipSet changed. ipSet is:', ipSet)
      getIPGeo()
    },
    {
      debounce: 500,
    },
  )

  return {
    ipSet,
    ipGeo,
    getIPGeo,
    addIP,
    getLocalGeoInfo,
    isValidIP,
  }
})
